import { useLayoutEffect, useState } from "react";

export function useHeadingsData(dep) {
  const [headings, setHeadings] = useState([]);

  useLayoutEffect(() => {
    if (dep == null) {
      setHeadings([]);
      return;
    }
    const elements = Array.from(document.querySelectorAll("h2"));
    const newHeadings = elements.map((el, index) => {
      const id = (index + 1).toString();
      if (!el.id) el.setAttribute("id", id);
      return {
        id,
        text: el.textContent,
      };
    });

    setHeadings(newHeadings);
  }, [dep]);

  return headings;
}
